import SectionEditor from '../components/SectionEditor';

export default function CountdownEditor(){
  const fields = [
    { key: 'title', label: 'Titel' },
    { key: 'targetISO', label: 'Zielzeitpunkt (ISO)', type: 'datetime-local', help: 'Lokale Zeit; wird als ISO gespeichert' },
  ];
  const defaults = {
    title: 'DAS FESTIVAL BEGINNT IN',
    targetISO: '2024-11-23T20:00',
  };
  return <SectionEditor sectionKey="countdown" title="Countdown" fields={fields} defaults={defaults} />;
}
